import paymentReportReducer from './PaymentReportReducer';
import otherPaymentReportReducer from './OtherPaymentReportReducer';
import dailyReportReducer from './dailyReportReducer';
import checkPostingReducer from './checkPostingReducer';
import claimAdjustmentReducer from './claimAdjustmentReducer';

const paymentReportReducers = {
  paymentReport: paymentReportReducer,
  otherPaymentReport: otherPaymentReportReducer,
  dailyReport: dailyReportReducer,
  checkPosting: checkPostingReducer,
  claimAdjustment: claimAdjustmentReducer,
};

export default paymentReportReducers;
